import { markRaw } from 'vue'

export default {
  namespaced: true,
  state: () => ({
    isVisible: false,
    config: {},
    resolve: null,
    reject: null
  }),
  mutations: {
    SHOW_MODAL(state, config) {
      state.config = config
      state.isVisible = true
    },
    HIDE_MODAL(state) {
      state.isVisible = false
      state.config = {
        props: {} // ← force clean
      }
      state.resolve = null
      state.reject = null
    },
    SET_PROMISE_HANDLERS(state, { resolve, reject }) {
      state.resolve = resolve
      state.reject = reject
    },
    SET_OK_DISABLED(state, value) {
      state.config = {
        ...state.config,
        okDisabled: value
      }
    }
  },
  actions: {
    showModal({ commit }, config) {
      const safeConfig = {
        ...config,
        okDisabled: config.okDisabled ?? false,
        cancelDisabled: config.cancelDisabled ?? false,
        okTitle: config.okTitle ?? 'OK',
        cancelTitle: config.okOnly ? undefined : (config.cancelTitle ?? 'Cancel'),
        component: config.component ? markRaw(config.component) : undefined,
        props: markRaw(config.props || {})
      }
      return new Promise((resolve, reject) => {
        commit('SHOW_MODAL', safeConfig)
        commit('SET_PROMISE_HANDLERS', { resolve, reject })
      })
    },
    confirm({ state, commit }) {
      state.resolve?.(true)
      commit('HIDE_MODAL')
    },
    cancel({ state, commit }) {
      state.reject?.(false)
      commit('HIDE_MODAL')
    },
    setOkDisabled({ commit }, value) {
      commit('SET_OK_DISABLED', value)
    }
  }
}
